import { enterpriseBasename } from '@/constants';

/**
 * prepends enterprise basename to provided link
 * if no link is provided, returns enterprise homepage
 */
export const asEnterpriseLink = (link?: string) => {
  return link ? `/${enterpriseBasename}/${link}` : `/${enterpriseBasename}`;
};
